import React, {  useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap'; 
import PropTypes from 'prop-types';
import PopUpRadioQuestions from '../../../Product/TermLifeInsurance/PopUps/PopUpRadioQuestions';
import { Button, makeStyles } from '@material-ui/core';
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../../sessionStorage';

const useStyles = makeStyles(theme => ({
  primaryText: {
    color: theme.palette.primary.main,

  }
}));

export default function Advisor(props) {
  const classes = useStyles();
  const [insString, setInsString] = useState(props.formState.insString);
  const [insuranceQuestion, setInsuranceQuestion] = useState(props.formState.advisorObj);
  const [showbutton, setshowbutton] = useState(true);
  const [currentStep, setCurrentStep] = useState(props.formState.currentStep);

  const setAnswer = (name = null, value = null, healthClassValue = null) => {

    setInsuranceQuestion({ ...insuranceQuestion, [name]: value })
    if (currentStep === 8) {
       getInsuranceString(value);
    }

    setCurrentStep(currentStep + 1)
  }

  const getSelectedInsurance = (product) =>{
    let newFormState  = {...props.fullFormState};
    newFormState.pages.advisor.advisorObj  = insuranceQuestion;
    newFormState.pages.advisor.currentStep = currentStep;
    newFormState.pages.advisor.insString = insString;
    sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, JSON.stringify(newFormState));
    props.history.push(`/Products/${product}/`);
  }

  const getInsuranceString = (value) => {
    let points = 0;
    if (insuranceQuestion.inheritance === 'Yes')
      points++;
    if (insuranceQuestion.financialSupport === 'Yes')
      points++;
    if (insuranceQuestion.leastExpensiveInc === 'No')
      points++;
    if (insuranceQuestion.limitedPeriodInc === 'No')
      points++;
    if (insuranceQuestion.deathbenefit === 'Yes')
      points++;
    if (insuranceQuestion.incBenefit === 'No')
      points++;
    if (insuranceQuestion.incImportance === 'Yes')
      points++;
    if (value === 'No')
      points++;

    let resultObj = {} 
    if (points === 0) {
        resultObj.term = '100% Term';
        resultObj.perm = '';
        resultObj.summary = "Clearly your client is concerned about protecting those who depend on them; however, today your client feel they only want coverage for a limited period of time. Based on your client's answers, a term life insurance policy with the option of future conversion should be considered based on your client's answers. The next section will help you understand which permanent policy your client may want to consider converting to in the future.";
    }
    if (points >= 1 && points <= 2) {
      resultObj.term = '75% Term';
      resultObj.perm = '25% Permanent';
      resultObj.summary = "Your client recognizes the importance of owning life insurance throughout their entire life; however, they also acknowledge that their biggest concern is protecting those who depend on them during their working years. Life insurance products with mostly term insurance and a small amount of permanent insurance should be considered based on their answers.";
    }
    if (points >= 3 && points <= 5) {
      resultObj.term = '50% Term';
      resultObj.perm = '50% Permanent';
      resultObj.summary = "Your client’s answers show that they appreciate both the benefits of permanent insurance and term insurance. Life insurance products consisting of equal amounts of term and permanent protection should be considered based on your client’s answers."
    }
    if (points >= 6 && points <= 7) {
       resultObj.term = '25% Term';
       resultObj.perm = '75% Permanent';
       resultObj.summary = "Protecting those who depend on them for their entire lifetime — regardless of how long they may live — is most important to your client. Their preferences indicate that life insurance products consisting mostly of permanent insurance should be considered based on their answers.";
    }
    if (points >= 8) {
      resultObj.term = '';
      resultObj.perm = '100% Permanent';
      resultObj.summary = "Your client wants lifetime protection, to leave a legacy and to protect your client's spouse’s retirement income. A permanent life insurance policy should be considered based on your client's answers."
    }
    setInsString(resultObj)
  }

  const startOver = () => {
    let newState = {
      inheritance: '',
      financialSupport: '',
      leastExpensiveInc: '',
      limitedPeriodInc: '',
      deathbenefit: '',
      incBenefit: '',
      incImportance: '',
      convertOption: '',
    }
    setInsuranceQuestion(newState);
    setCurrentStep(1);
  }

  const goBack = () => {
    if (currentStep === 1) {
      setshowbutton(!showbutton)
    }
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  }

  const steps = [
    {
      step: 1,
      component: (
        <PopUpRadioQuestions question='The idea of leaving an inheritance is important to my client — either for their family or a charitable organization. My client would want to do this in an efficient manner.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='inheritance'
          setAnswer={setAnswer}
          value={insuranceQuestion.inheritance}
          isNeedsAnalysis={true}
          step={1}
        />
      )
    },
    {
      step: 2,
      component: (
        <PopUpRadioQuestions question='In the future, my client’s adult children and/or parents may rely on them for financial support. They want to make sure their life insurance policy is there if they need it.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='financialSupport'
          setAnswer={setAnswer}
          value={insuranceQuestion.financialSupport}
          isNeedsAnalysis={true}
          step={2}
        />
      )
    },
    {
      step: 3,
      component: (
        <PopUpRadioQuestions question='My client would prefer the least expensive type of life insurance, even though their benefits may expire at some point in the future.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='leastExpensiveInc'
          setAnswer={setAnswer}
          value={insuranceQuestion.leastExpensiveInc}
          isNeedsAnalysis={true}
          step={3}
        />
      )
    },
    {
      step: 4,
      component: (
        <PopUpRadioQuestions question='My client only wants life insurance for a limited period of time (e.g., until their mortgage is paid, children finish college, or other financial obligations are met).'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='limitedPeriodInc'
          setAnswer={setAnswer}
          value={insuranceQuestion.limitedPeriodInc}
          isNeedsAnalysis={true}
          step={4}
        />
      )
    },
    {
      step: 5,
      component: (
        <PopUpRadioQuestions question='If my client dies prior to their spouse during retirement, they want to ensure he or she receives a life insurance death benefit.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='deathbenefit'
          setAnswer={setAnswer}
          value={insuranceQuestion.deathbenefit}
          isNeedsAnalysis={true}
          step={5}
        />
      )
    },
    {
      step: 6,
      component: (
        <PopUpRadioQuestions question='My client only wants their family to receive a life insurance benefit to replace their income if they were to die during their working years.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='incBenefit'
          setAnswer={setAnswer}
          value={insuranceQuestion.incBenefit}
          isNeedsAnalysis={true}
          step={6}
        />
      )
    },
    {
      step: 7,
      component: (
        <PopUpRadioQuestions question='Regardless of how long my client may live, it’s important for them to have their life insurance in place when they die.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='incImportance'
          setAnswer={setAnswer}
          value={insuranceQuestion.incImportance}
          isNeedsAnalysis={true}
          step={7}
        />
      )
    },
    {
      step: 8,
      component: (
        <PopUpRadioQuestions question='My client does not want to commit to permanent insurance today, however they would like to have the right to convert term coverage into permanent coverage in the future should their situation change without having to undergo additional medical screening.'
          options={[
            { value: 'Yes', label: "Agree" },
            { value: 'No', label: "Disagree" },
          ]}
          onStartOver={startOver}
          onBack={goBack}
          id='convertOption'
          setAnswer={setAnswer}
          value={insuranceQuestion.convertOption}
          isNeedsAnalysis={true}
          step={8}
        />
      )
    },
    {
      step: 9,
      component: (
        <PopUpRadioQuestions
          question=""
          onStartOver={startOver}
          onBack={goBack}
          getSelectedInsurance = {(ins)=>getSelectedInsurance(ins)}
          id='final_screen'
          result={insString}
          isNeedsAnalysis={true}
          history={props.history}
        />
      )
    }
  ]
  const currentStepObj = steps.find(s => s.step === currentStep);

  return (
    <Container fluid className="px-0">
      <h3 className='mb-3'>Determine the Best Type of Life Insurance For Your Client </h3>
      {currentStepObj.component}
      <h4 className={`${classes.primaryText} mt-5`}>Learn More about Term vs. Permanent Insurance</h4>
      <Row className='mt-2'>
        <Col sm={4}>
        <div className="embed-responsive embed-responsive-16by9 mt-2">
          <iframe src={"https://player.vimeo.com/video/138321296?title=0&amp;byline=0&amp;portrait=0&toolbar=1%22"} className="embed-responsive-item" title="term-vs-perm" />
          </div>
        </Col>
        <Col sm={4}>
          <h4 className={`${classes.primaryText} mb-2 px-3`}>Term Insurance</h4>
          <p className='need-analysis-text px-3'> Term insurance is like leasing a car. You purchase death benefits for a specified period - usually 5, 10 or 20 years. When the period is over, it's like turning in the leased car. The deal is done and you walk away. Therefore, people typically purchase term insurance when they need a fix amount of coverage for a limited period of time, usually to cover their income during their working years or while they have dependents.</p>
        </Col>
        <Col sm={4}>
          <h4 className={`${classes.primaryText} mb-2 pr-3`}>Permanent Insurance</h4>
          <p className='need-analysis-text pr-3'>Permanent insurance, on the other hand, is like buying a car you plan to drive forever. Eventually you are done making payments but you still have the car.  Permanent insurance stays in force as long as you live. It will pay a death benefit, and it accumulates a tax-deferred cash value that you can borrow against or withdraw during your retirement years.</p>
        </Col>
      </Row>
      <Row className="pt-4">
        <Col className="text-left button-back">
          <Button variant="outlined" size="medium" color="primary" onClick={props.onBack} >BACK</Button>
        </Col>
      </Row>
    </Container>
  );
}

Advisor.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

Advisor.DefaultFormState = () =>{
  return {
    advisorObj : {
      inheritance: '',
      financialSupport: '',
      leastExpensiveInc: '',
      limitedPeriodInc: '',
      deathbenefit: '',
      incBenefit: '',
      incImportance: '',
      convertOption: ''
    },
    currentStep:1,
    insString:{},
  }
}




// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/Advisor.js